<div class="top">
    <div class="heading">
        <span class="fw-bold" style="font-size: 18px; text-transform: uppercase;">TAXPAYER PROFILE</span>
    </div>
    <i class="material-icons text-danger" role="button" (click)="closeModal()">
        close
    </i>
</div>


<div class="form-wrapper">
    <div class="image-container">
        <img src="/assets/images/user-placeholder.png" alt="">
    </div>

    <div class="content">
        <div class="details">
            <div class="d-flex gap-4 justify-content-between flex-wrap mb-4">
                <div class="left d-flex flex-column gap-2">
                    <h4 class="fw-bold text-uppercase" style="font-size: 20px;">{{this.dialogData?.displayName}}</h4>
                    <div><strong class="fw-bold">ASIN: </strong> {{ this.details?.asin }}</div>
                    <div><strong class="fw-bold">Phone: </strong> {{ this.details?.phoneNumber }}</div>
                    <!-- <div><strong class="fw-bold">Email: </strong> {{ this.details?.email }}</div> -->
                    <!-- <div><strong class="fw-bold">Address: </strong> {{ this.details?.address }}</div> -->
                </div>

                <div class="d-flex flex-column gap-2 align-items-start align-items-sm-end ">
                    <!-- <div class="d-flex align-items-center gap-1">
                        <span class="font-size-small text-nowrap">Agent Type:</span>
                        <span
                            style="background-color: #F2EACF; color: #686988; padding: 3px 15px; border-radius: 999px; font-size: 13px;">{{this.details?.roleName
                            | removeUnderscore }}</span>
                    </div> -->
                    <div class="d-flex flex-column align-items-start align-items-sm-end gap-1">
                        <p style="font-size: 13px; color: #6B6C7E;">Date of Registration:</p> <small class="fw-bold"
                            style="font-size: 13px;">{{ this.details?.createdAt | date }}</small>
                    </div>
                </div>
            </div>
        </div>


        <form [formGroup]="form" (ngSubmit)="addItemToList()" style="border-top: 1px solid #e0e0e0; padding-top: 20px;">
            <div class="query-reason" *ngIf="dialogData?.approvalStatus == 'QUERIED'">REASON FOR QUERY: {{this.details?.comment}}</div>

            <h6 class="text-decoration-underline fw-bold">PROFILING DETAILS</h6>
            <div class="d-flex gap-2 flex-wrap assessment-form" *ngIf="isEditingAllowed">
                <!-- <div class="field ">
                        <label for="name" class="required">Assessment Type</label>
                        <ng-select [items]="assessmentTypes || []" [searchable]="true" [closeOnSelect]="true"
                             placeholder="Select option" formControlName="assessmentType"
                            class="ng-select control ng-select-text-sm" bindValue="value" bindLabel="label" [readonly]="!assessmentTypes">
                
                        </ng-select>
                        <app-error-message [form]="form" controlName="assessmentType" label="Assessment Type" style="height: 16px;"
                            [showErrorMessage]="showErrorMessages"></app-error-message>
                    </div> -->
                <div class="field ">
                    <label for="name" class="required">Profiling Type <span class="spinner-light"
                            *ngIf="isFetchingProfilingTypes"></span> </label>
                    <ng-select [items]="profilingTypes || []" [searchable]="true" [closeOnSelect]="true"
                        bindLabel="category" bindValue="id" placeholder="Select option" formControlName="profilingType"
                        class="ng-select control ng-select-text-sm" [readonly]="!profilingTypes">
                    </ng-select>
                    <app-error-message [form]="form" controlName="profilingType" label="Profiling type"
                        [showErrorMessage]="showErrorMessages"></app-error-message>
                </div>
                <div class="field ">
                    <label for="name" class="required">CATEGORY <div class="spinner-light" style="height: 10px;"
                            *ngIf="isFetchingCategories"></div> </label>
                    <div class="d-flex gap-1">
                        <ng-select [items]="categories || []" [searchable]="true" [closeOnSelect]="true"
                            bindLabel="revenueDescription" bindValue="id" placeholder="Select option"
                            formControlName="category" class="w-100 ng-select control ng-select-text-sm"
                            [readonly]="!categories">
                        </ng-select>

                        <button class="btn btn-dark d-flex align-items-center gap-1" [disabled]="isSubmitting"
                            style="flex-wrap: nowrap; height: 40px; border-radius: 4px;" type="submit">
                            <svg width="14" height="13" viewBox="0 0 14 13" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <mask id="mask0_8839_7438" style="mask-type: luminance" maskUnits="userSpaceOnUse" x="0"
                                    y="0" width="14" height="13">
                                    <path
                                        d="M6.70118 10.8201C9.12505 10.8201 11.0899 8.85527 11.0899 6.4314C11.0899 4.00754 9.12505 2.04272 6.70118 2.04272C4.27731 2.04272 2.3125 4.00754 2.3125 6.4314C2.3125 8.85527 4.27731 10.8201 6.70118 10.8201Z"
                                        fill="white" stroke="white" stroke-width="4.06307" stroke-linejoin="round" />
                                    <path d="M6.75616 4.24121V8.19102M4.78125 6.21612H8.73106" stroke="black"
                                        stroke-width="1.01577" stroke-linecap="round" stroke-linejoin="round" />
                                </mask>
                                <g mask="url(#mask0_8839_7438)">
                                    <path d="M-13.1406 -13.4124H24.7776V24.5058H-13.1406V-13.4124Z" fill="white" />
                                </g>
                            </svg>
                            ADD
                        </button>
                    </div>
                    <app-error-message [form]="form" controlName="category" label="Category"
                        [showErrorMessage]="showErrorMessages"></app-error-message>
                </div>

            </div>

            <table class="custom-table table-bordered amc-table" appAutoDataLabel>
                <thead class="custom-table-heading">
                    <tr>
                        <th class="ps-4">Profiling Type</th>
                        <th>Category</th>
                        <th>Amount</th>
                        <th class="text-center"
                            *ngIf="isEditingAllowed && hasAccess( ['CAN_UPDATE_IGR_ASSESSMENT', 'CAN_UPDATE_IGR_ASSESSMENT'])">
                            Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of itemList; let i = index">
                        <td>{{ item?.profilingType?.category | uppercase }}</td>
                        <td>{{ item?.category?.revenueDescription | titlecase }}</td>
                        <td>{{ item.category?.amount | nairaCurrency }}</td>
                        <td
                            *ngIf="isEditingAllowed && hasAccess( ['CAN_UPDATE_IGR_ASSESSMENT', 'CAN_UPDATE_IGR_ASSESSMENT'])">
                            <div class="d-flex justify-content-center">
                                <button class="btn btn-danger table-action-btn" (click)="removeItem(i)"
                                    [disabled]="isSubmitting">
                                    Delete
                                </button>
                            </div>
                        </td>
                    </tr>

                    <tr *ngIf="!itemList">
                        <td>
                            <div class="spinner-light"></div>
                        </td>
                        <td>
                            <div class="spinner-light"></div>
                        </td>
                        <td>
                            <div class="spinner-light"></div>
                        </td>
                        <td
                            *ngIf="isEditingAllowed && hasAccess( ['CAN_UPDATE_IGR_ASSESSMENT', 'CAN_UPDATE_IGR_ASSESSMENT'])">
                            <div class="spinner-light"></div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </form>

        <div role="button"
            *ngIf="!isEditingAllowed && hasAccess( ['CAN_UPDATE_IGR_ASSESSMENT', 'CAN_UPDATE_IGR_ASSESSMENT']) && dialogData?.approvalStatus != 'APPROVED'"
            style="color: blue; align-items: center; display: flex; gap: 3px; justify-content: end; margin-top: 15px; "
            (click)="allowEditing()">
            <span class="material-icons">edit</span>
            Edit
        </div>

        <div class="modal-actions-wrapper mt-3"
            *ngIf="hasAccess(['CAN_APPROVE_IGR_ASSESSMENT', 'CAN_QUERY_IGR_ASSESSMENT']) && details?.approvalStatus == 'PENDING' && details?.currentApproverId == currentUser?.id">

            <button type="submit" class="btn flex-btn btn-danger w-100" (click)="queryApplication()">
                <span>QUERY</span>
                <span class="spinner-light" *ngIf="isQueryingApplication"></span>
            </button>

            <button type="submit" class="btn flex-btn btn-success w-100" (click)="approveApplication()">
                <span>APPROVE</span>
                <span class="spinner-light" *ngIf="isApprovingApplication"></span>
            </button>

        </div>

        <div class="modal-actions-wrapper mt-3"
            *ngIf="hasAccess(['CAN_CREATE_IGR_ASSESSMENT', 'CAN_UPDATE_IGR_ASSESSMENT']) && dialogData?.approvalStatus == 'PENDING' && isEditingAllowed">
            <button type="submit" class="custom-btn-primary w-100" [disabled]="!isListUpdated || itemList?.length < 1"
                (click)="reassessApplication()">
                <ng-container *ngIf="!isUpdatingApplication; else loadingTemplate">
                    <span>{{ 'Create Re-assessment' }}</span>
                </ng-container>
                <ng-template #loadingTemplate>
                    <span>Saving...</span>
                    <div class="spinner-light"></div>
                </ng-template>
            </button>
        </div>

        <div class="modal-actions-wrapper mt-3"
            *ngIf="hasAccess(['CAN_CREATE_IGR_ASSESSMENT', 'CAN_UPDATE_IGR_ASSESSMENT']) && dialogData?.approvalStatus == 'QUERIED' && isEditingAllowed">
            <button type="submit" class="custom-btn-primary w-100" [disabled]="!isListUpdated || itemList?.length < 1"
                (click)="updateApplication()">
                <ng-container *ngIf="!isUpdatingApplication; else loadingTemplate">
                    <span>{{ 'Update Assessment' }}</span>
                </ng-container>
                <ng-template #loadingTemplate>
                    <span>Saving...</span>
                    <div class="spinner-light"></div>
                </ng-template>
            </button>
        </div>
    </div>


</div>